var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legende-deco"},[_c('div',{staticClass:"texte"},[_vm._t("default")],2),_c('div',{staticClass:"deco"})])}
var staticRenderFns = []

export { render, staticRenderFns }